<template>
  <div id="formulario-edit-info">   
    <ExibirErrosConcept :errorsValidacao="errorsValidacao" ref="errosComponent"></ExibirErrosConcept>
    <vx-card>
        <div class="vx-row mb-4">
            <div class="vx-col md:w-1/2 w-full">                    
                <vs-button class="ml-auto mt-2" size="small" @click="gravar" color="success">Gravar</vs-button>
                <vs-button class="ml-4 mt-2" size="small" @click="excluir" v-show="isDeletable" color="danger">Inativar</vs-button>            
                <vs-button class="ml-4 mt-2" size="small" type="border" color="dark" @click="voltar">Voltar</vs-button>             
            </div>
        </div>
        <div class="vx-row">
            <div class="vx-col w-1/2"><vs-checkbox class="w-full" v-model="data_local.excluido"> INATIVO ? </vs-checkbox> </div>     
            <div class="vx-col w-1/2"></div>                 
        </div>    
        
        <div class="vx-row">
            <div class="vx-col w-1/2"><label class="vs-input--label">Razão Social</label></div>     
            <div class="vx-col w-1/2"><label class="vs-input--label">Nome Fantasia</label></div>                 
        </div>    
        <div class="vx-row">
            <div class="vx-col w-1/2 flex">
                <vs-input class="w-full" v-model="data_local.razaoSocial" :maxlength="255"/>   
            </div>     
            <div class="vx-col w-1/2 flex">
                <vs-input class="w-full" v-model="data_local.nomeFantasia" :maxlength="255"/>   
            </div>                 
        </div>    
        <div class="vx-row mt-3">
            <div class="vx-col w-1/2"><label class="vs-input--label">CNPJ</label></div>                             
            <div class="vx-col w-1/2"><label class="vs-input--label">TELEFONE</label></div>                             
        </div>    
        <div class="vx-row">
            <div class="vx-col w-1/2 flex">
                <vs-input class="w-full" v-model="data_local.cnpj" :maxlength="20"/>   
            </div>                     
            <div class="vx-col w-1/2 flex">
                <vs-input class="w-full" v-model="data_local.telefone"/>   
            </div>                     
        </div> 
        <div class="vx-row mt-3">
            <div class="vx-col w-full"><label class="vs-input--label">Endereço</label></div>                                         
        </div>                    
        <div class="vx-row">
            <div class="vx-col w-3/4 flex">
                <vs-input class="w-full" v-model="data_local.endereco"/>   
            </div>                     
            <div class="vx-col w-1/4 flex">
                <vs-input class="w-full" v-model="data_local.numero"/>   
            </div>                     
        </div>   
        <div class="vx-row mt-3">
            <div class="vx-col w-1/3"><label class="vs-input--label">Bairro</label></div>                                         
            <div class="vx-col w-1/3"><label class="vs-input--label">Cidade</label></div>                                         
            <div class="vx-col w-1/3"><label class="vs-input--label">Estado</label></div>                                         
        </div>    
        <div class="vx-row">
            <div class="vx-col w-1/3 flex">
                <vs-input class="w-full" v-model="data_local.bairro"/>   
            </div>     
            <div class="vx-col w-1/3 flex">
                <vs-input class="w-full" v-model="data_local.cidade"/>   
            </div>     
            <div class="vx-col w-1/3 flex">
                <v-select                                               
                    :options="CONSTANTE_UFS" 
                    v-model="data_local.estado"    
                    :clearable="false"
                    :reduce="r => r.data"                                                                         
                    class="v-select w-full">
                </v-select>  
            </div>     
        </div>
        <div class="vx-row mt-3">
            <div class="vx-col w-1/3"><label class="vs-input--label">CEP</label></div>     
            <div class="vx-col w-1/3"><label class="vs-input--label">Email</label></div>     
            <div class="vx-col w-1/3"><label class="vs-input--label">Site</label></div>                 
        </div>    
        <div class="vx-row">
            <div class="vx-col w-1/3 flex">
                <vs-input class="w-full" v-model="data_local.cep" :maxlength="9"/>   
            </div>     
            <div class="vx-col w-1/3 flex">
                <vs-input class="w-full" v-model="data_local.email" :maxlength="255"/>   
            </div>     
            <div class="vx-col w-1/3 flex">
                <vs-input class="w-full" v-model="data_local.site" :maxlength="255"/>   
            </div>                 
        </div>            
    </vx-card>  
  </div>
</template>

<script>
import axios from "@/axios.js"
import VueAutonumeric from 'vue-autonumeric/src/components/VueAutonumeric.vue';
import { CONSTANTE_UFS } from '@/constantesComboBox.js'

const URL_SERVLET = "/Empresa";
const NAME_ROUTE_SEARCH = "cadastro-empresas-pesquisar";

export default { 
  components: {  
    VueAutonumeric
  },      
  props: {
    registroOriginal: {
      type: Object,
      required: false,
      default: function () {
        return { nomeFantasia: null, razaoSocial: null, cnpj: null, endereco:null, numero:null, bairro:null, cep:null, cidade:null, estado:null, site:null, 
            email:null, telefone:false,excluido: false }
       }
    },
  },
  data() {
    return {        
        errorsValidacao: [],  
        data_local: JSON.parse(JSON.stringify(this.registroOriginal)),           
    }
  },  
  created(){
    this.CONSTANTE_UFS = CONSTANTE_UFS;
  }, 
  mounted() {
    if (this.registroOriginal.hasOwnProperty('id')) {
          this.findById();  
    } 
  },
  computed: {        
    isDeletable() {
       return this.data_local != null && this.data_local.hasOwnProperty("id");
    },    
  },
  methods: {  
    findById() {
        const params = new URLSearchParams();       
        params.append('id', this.data_local.id);           
                
        axios.post(URL_SERVLET + "/RecuperarEmpresa", params, {              
            headers: {'Accept': 'application/json' }, credentials: 'include', responseEncoding: 'iso88591', withCredentials: true } )
        .then((response) => {
            if (response.data.hasOwnProperty("codigo") && response.data.codigo === "99" ) {
                this.$router.push({ path: '/login' });
            } else {                
                 this.data_local = response.data.Empresa;                 
            }
        })
        .catch((error) => { 
            /* eslint-disable no-console */  console.log("EFETUAR LOGOFF! - gravar - " + error); 
        })  
    }, 
    excluir() {
        this.$vs.dialog({
          type: 'confirm', color: 'warning', title: 'Atenção', text: 'Deseja excluir ?', acceptText: 'Sim', cancelText: 'Não', accept: this.excluirRequest
        });
    },
    excluirRequest() {
        this.$vs.loading();  
        const params = new URLSearchParams();        
        params.append('outputFormat', 'JSON');
        params.append('method', 'Delete');      
        params.append('id', this.data_local.id);   
                
        axios.post(URL_SERVLET + "/RemoverEmpresa", params, {              
                credentials: 'include', responseEncoding: 'iso88591', withCredentials: true } )
        .then((response) => {
            if (response.data.hasOwnProperty("codigo") && response.data.codigo === "99" ) {
                this.$router.push({ path: '/' });
            } else {
                this.$vs.loading.close();
                if (response.data.hasOwnProperty("error")) {
                        this.$vs.dialog({ color: 'danger', title: 'Erro', text: response.data.error, acceptText: 'OK'})
                } else {
                    this.$router.push({ name: NAME_ROUTE_SEARCH })
                }                   
            }
        })
        .catch((error) => { 
            this.$vs.loading.close();
            /* eslint-disable no-console */ console.log("EFETUAR LOGOFF! - gravar - " + error); 
        })  
    },
    gravar() {        
        if (this.formularioValido()) { 
            this.$vs.loading();  
            const params = new URLSearchParams();    
            let key;    
            for(key in this.data_local) {
                params.append(key, this.data_local[key]);
            }

            axios.post(URL_SERVLET + "/GravarEmpresa", params, {              
                    credentials: 'include', responseEncoding: 'iso88591', withCredentials: true } )
            .then((response) => {
                this.$vs.loading.close();
                if (response.data.hasOwnProperty("codigo") && response.data.codigo === "99" ) {
                    this.$router.push({ path: '/' });
                } else {                    
                    if (response.data.hasOwnProperty("error")) {
                            this.$vs.dialog({ color: 'danger', title: 'Erro', text: response.data.error, acceptText: 'OK'})
                    } else {
                        this.$router.push({ name: NAME_ROUTE_SEARCH })
                    }                   
                }
            })
            .catch((error) => { 
                this.$vs.loading.close();
                /* eslint-disable no-console */ console.log("EFETUAR LOGOFF! - gravar - " + error); 
            })  
        }
         
    },
    voltar() {
        this.$router.push({
            name: NAME_ROUTE_SEARCH                     
        })
    },
    formularioValido() {
        this.$refs.errosComponent.iniciar();
        this.errorsValidacao = [];
      
        if (!this.data_local.nomeFantasia) { this.errorsValidacao.push("Nome obrigatório"); }
        if (!this.data_local.razaoSocial) { this.errorsValidacao.push("Razão Social obrigatório"); }
        if (!this.data_local.cnpj) { this.errorsValidacao.push("CNPJ obrigatório"); }
        if (!this.data_local.telefone) { this.errorsValidacao.push("Telefone obrigatório"); }
        if (!this.data_local.endereco) { this.errorsValidacao.push("Endereço obrigatório"); }
        if (!this.data_local.numero) { this.errorsValidacao.push("Número do Endereço obrigatório"); }
        if (!this.data_local.bairro) { this.errorsValidacao.push("Bairro obrigatório"); }
        if (!this.data_local.cidade) { this.errorsValidacao.push("Cidade obrigatório"); }
        if (!this.data_local.estado) { this.errorsValidacao.push("Estado obrigatório"); }
        if (!this.data_local.cep) { this.errorsValidacao.push("CEP obrigatório"); }
        if (!this.data_local.email) { this.errorsValidacao.push("Email obrigatório"); }
        if (!this.data_local.site) { this.errorsValidacao.push("Site obrigatório"); }

        if (!this.errorsValidacao.length) {
            return true;
        }   
        return false;
    },
  }
}
</script>

<style scoped>
  .tabelaComScroll {      
      overflow: auto;  
      height: calc(100vh - 300px);
      position: relative;      
    } 
</style>